import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Icon } from '../Elements';

import classes from './SortingIcon.module.scss';

const SortingIcon = ({ direction, fieldName, field, onClick }) => {
  return (
    <Icon
      size="16px"
      icon="arrow"
      onClick={onClick}
      className={cn(
        classes.icon,
        direction > 0 ? classes.icon_up : classes.icon_down,
        fieldName === field ? classes.icon_visible : classes.icon_invisible
      )}
    />
  );
};

SortingIcon.propTypes = {
  fieldName: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  direction: PropTypes.number.isRequired,
  onClick: PropTypes.func
};

export default SortingIcon;
